import { stateOptions } from "@/config/stateOptions";

// "" is the All choice of both filters, so a v-select can show it as the selected item.
export const stateFilterOptions = [{ text: "All", value: "" }, ...stateOptions];

export const typeOptions = [
  { text: "All", value: "" },
  { text: "PPPoE", value: "PPPoE" },
  { text: "IPoE", value: "IPoE" },
];

// The request for visp/GetIpAddresses. Every matching row is fetched (pageSize 0) because the grid pages on the client.
export function buildIpAddressSearch({ keyword, showAvailable, showAssigned, showQuarantined, state, type }) {
  const request = {
    search: keyword || "",
    showAvailable,
    showAssigned,
    showQuarantined,
    pageSize: 0,
  };
  if (state) request.state = state;
  if (type) request.isIpoe = type === "IPoE";
  return request;
}

// Show All (a size of 0 or less) is one page holding every row.
export function gridPageSize(selected, rowCount) {
  return selected > 0 ? selected : Math.max(rowCount, 1);
}
